import React from 'react';
import LanguageSpreadSheet from '../../../../components/siteadmin/MobileLanguageInfo/LanguageSpreadSheet';
import { manageAndroidMobileLanguage, manageFlutterMobileLanguage, manageiOSMobileLanguage } from '../../../../config';
import NotFound from '../../../notFound/NotFound';

function EditMobileLanguage({ languageCode, title, appType, isMobileLanguageRestricted }) {
  if ((appType == "android_app" && manageAndroidMobileLanguage != "true") || (appType == "iOS_app" && manageiOSMobileLanguage != "true") || (appType == "flutter_app" && manageFlutterMobileLanguage != "true")) {
    return (
      <NotFound />
    )
  }
  return (
    <LanguageSpreadSheet languageCode={languageCode} title={title} appType={appType} isMobileLanguageRestricted={isMobileLanguageRestricted} />
  );
}

export default EditMobileLanguage;